<template>
  <div v-if="accordionData.length" id="Accordion">
    <div
      v-for="(item, index) in accordionData"
      :key="index"
      class="accordion-item-container"
    >
      <RouterLink
        v-if="item.redirectTo"
        :to="item.redirectTo"
        :target="item.isOpenInSameTab ? '_self' : '_blank'"
        class="accordion-item-inner"
      >
        <div class="accordion-header">
          <p class="accordion-title brand-highlight-3">{{ item.title }}</p>
          <i class="fa fa-external-link accordion-arrow" aria-hidden="true"></i>
        </div>
      </RouterLink>
      <a 
        v-else-if="item.defaultLink"
        :href="item.defaultLink"
        target="_blank"
        class="accordion-item-inner"
      >
        <div class="accordion-header">
          <p class="accordion-title brand-highlight-3">{{ item.title }}</p>
          <i class="fa fa-external-link accordion-arrow" aria-hidden="true"></i>
        </div>
      </a>
      <button v-else-if="item.content" @click="toggle(index)" class="accordion-item-inner accordion-button px-0">
        <div class="accordion-header">
          <p class="accordion-title brand-highlight-3">{{ item.title }}</p>
          <i
            v-if="isOpen(index)"
            class="fa fa-chevron-up brand-highlight-3"
            aria-hidden="true"
          ></i>
          <i
            v-else
            class="fa fa-chevron-right accordion-arrow"
            aria-hidden="true"
          ></i>
        </div>
        <div v-if="isOpen(index)" class="accordion-content">
          <p class="brand-text">{{ item.content }}</p>
        </div>
      </button>
      <div v-else-if="item.videoData" class="accordion-item-inner px-0">
        <button @click="toggle(index)" class="accordion-header accordion-button px-0">
          <p class="accordion-title brand-highlight-3">{{ item.title }}</p>
          <i
            v-if="isOpen(index)"
            class="fa fa-chevron-up brand-highlight-3"
            aria-hidden="true"
          ></i>
          <i
            v-else
            class="fa fa-chevron-right accordion-arrow"
            aria-hidden="true"
          ></i>
        </button>
        <div v-if="isOpen(index)" class="accordion-content">
          <RelatedContentList :videoArray="item.videoData"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RelatedContentList from './RelatedContentList.vue';

export default {
  name: "MyHealthAccordion",
  components: {
    RelatedContentList
  },
  data() {
    return {
      openIndex: null
    };
  },
  props: {
    accordionData: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  methods: {
    toggle(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
    isOpen(index) {
      return this.openIndex === index;
    }
  }
};
</script>

<style scoped>
#Accordion {
  width: 100%;
  margin-bottom: 8px;

  .accordion-item-container {
    padding: 20px 0;
    transition: color 0.3s;

    &:not(:last-child) {
      border-bottom: 1px solid #e0e5f5;
    }

    &:hover .accordion-arrow {
      color: #192550;
    }
  }

  .accordion-item-inner {
    cursor: pointer;
    font-family: "PlusJakartaSansBold";
  }

  .accordion-button {
    width: 100%;
    border: none;
    background-color: unset;
  }

  .accordion-arrow {
    color: #aeb0bd;
    transition: color 0.3s;
  }

  .accordion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.8rem !important;
  }

  .accordion-title {
    margin-bottom: 0;
  }

  .accordion-content {
    text-align: left;
    font-size: 1.8rem;
    line-height: 2.5rem;
    font-family: "PlusJakartaSansRegular";
    white-space: pre-wrap;
    margin-top: 8px;
  }

  .accordion-content p {
    margin: 0;
  }
}
</style>
